import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { EventsV4Service } from '../../shared/events-v4.service';
import { EventRead } from '../../shared/event-read.model';
import { UtilService } from '../../../shared/index';
import { EventSignUpNotificationEmail } from '../../shared/notifications/event-signup-notification-email.model';
import { UserRead } from '../../../users/shared/user-read.model';
import { EventPaymentMethod } from '../../shared/payment-methods/event-payment-method.model';
import { EntityService } from '../../../entity/shared/entity.service';
import { Entity } from '../../../entity/shared/entity.model';
import { PlatformService } from '../../../shared/platform/platform.service';
import { EventV4RegistrationService } from '../../shared/registration/event-v4-registration.service';
import { ModificationTypeEnum } from '../../shared/modification-type.enum';

@Component({
  selector: 'wl-event-v4-settings-registration-settings',
  templateUrl: 'event-v4-settings-registration-settings.component.html',
  styleUrls: ['event-v4-settings-registration-settings.component.less'],
  providers: [EntityService, EventsV4Service],
    standalone: false
})
export class EventV4SettingsRegistrationSettingsComponent implements OnInit {
  public _event: EventRead = new EventRead();
  public entities: Array<Entity>;
  public modificationTypeEnum = ModificationTypeEnum;

  private _showEditor = false;
  @Input() public get showEditor() {
    return this._showEditor;
  }
  set showEditor(value: boolean) {
    this._showEditor = value;
  }

  /**
   * construct
   * @param dialogService
   */
  public constructor(
    private _utilService: UtilService,
    private _entityService: EntityService,
    private _platformService: PlatformService,
    private _registrationService: EventV4RegistrationService
  ) {
    this.entities = new Array<Entity>();
  }

  ngOnInit() {
    this._entityService.getEntities().then((data: Array<Entity>) => {
      this.entities = data;
    });
  }

  @Input() public get event(): EventRead {
    return this._event;
  }
  public set event(value: EventRead) {
    this._event = value;

    if (!this._event) return;

    this._showSpecialDetailsPageURL = !!this._event.SpecialDetailsPageURL;
    this._showSpecialRegistrationUrl = !!this._event.SpecialRegistrationUrl;
    this._showRelatedWebsite = !!this._event.RelatedWebsite;
    this._showMapLink = !!this._event.ShowMap;
    this._showOverrideMapLink = !!this._event.MapLink;
    this._showWeatherLink = !!this._event.WeatherLink;
    this._backSendQuestionsToEmail = this.event.SendQuestionsToEmail;
    this._showSendQuestions = !!this.event.SendQuestionsToEmail;
  }

  @Output() public onValidChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public _showSendQuestions: boolean = false;
  public _showSpecialDetailsPageURL: boolean = false;
  public _showSpecialRegistrationUrl: boolean = false;
  public _showRelatedWebsite: boolean = false;
  public _showMapLink: boolean = false;
  public _showOverrideMapLink: boolean = false;
  public _showWeatherLink: boolean = false;

  public _backSendQuestionsToEmail: string = '';
  public _backSpecialDetailsPageURL: string = '';
  public _backSpecialRegistrationUrl: string = '';
  public _backRelatedWebsite: string = '';
  public _backMapLink: string = '';
  public _backWeatherLink: string = '';

  public get showSendQuestions(): boolean {
    return this._showSendQuestions;
  }

  public set showSendQuestions(value: boolean) {
    this._showSendQuestions = value;

    if (value) {
      this._event.SendQuestionsToEmail = this._backSendQuestionsToEmail;
    } else {
      if (this._event.SendQuestionsToEmail) this._backSendQuestionsToEmail = this._event.SendQuestionsToEmail;
      this._event.SendQuestionsToEmail = '';
    }
  }

  public get showSpecialDetailsPageURL(): boolean {
    return this._showSpecialDetailsPageURL;
  }

  public set showSpecialDetailsPageURL(value: boolean) {
    this._showSpecialDetailsPageURL = value;

    if (value) {
      this._event.SpecialDetailsPageURL = this._backSpecialDetailsPageURL;
    } else {
      if (this._event.SpecialDetailsPageURL) this._backSpecialDetailsPageURL = this._event.SpecialDetailsPageURL;
      this._event.SpecialDetailsPageURL = '';
    }
  }

  public get showSpecialRegistrationUrl(): boolean {
    return this._showSpecialRegistrationUrl;
  }

  public set showSpecialRegistrationUrl(value: boolean) {
    this._showSpecialRegistrationUrl = value;

    if (value) {
      this._event.SpecialRegistrationUrl = this._backSpecialRegistrationUrl;
    } else {
      if (this._event.SpecialRegistrationUrl) this._backSpecialRegistrationUrl = this._event.SpecialRegistrationUrl;
      this._event.SpecialRegistrationUrl = '';
    }
  }

  public get showRelatedWebsite(): boolean {
    return this._showRelatedWebsite;
  }

  public set showRelatedWebsite(value: boolean) {
    this._showRelatedWebsite = value;
    if (value) {
      this._event.RelatedWebsite = this._backRelatedWebsite;
    } else {
      if (this._event.RelatedWebsite) this._backRelatedWebsite = this._event.RelatedWebsite;
      this._event.RelatedWebsite = '';
    }
  }

  public get showMapLink(): boolean {
    return this._showMapLink;
  }

  public set showMapLink(value: boolean) {
    this._showMapLink = value;
    if (!value) this.showOverrideMapLink = false;
  }

  public get showOverrideMapLink(): boolean {
    return this._showOverrideMapLink;
  }

  public set showOverrideMapLink(value: boolean) {
    this._showOverrideMapLink = value;

    if (value) {
      this._event.MapLink = this._backMapLink;
    } else {
      if (this._event.MapLink) this._backMapLink = this._event.MapLink;
      this._event.MapLink = '';
    }
  }

  public get showWeatherLink(): boolean {
    return this._showWeatherLink;
  }

  public set showWeatherLink(value: boolean) {
    this._showWeatherLink = value;

    if (value) {
      this._event.WeatherLink = this._backWeatherLink;
    } else {
      if (this._event.WeatherLink) this._backWeatherLink = this._event.WeatherLink;
      this._event.WeatherLink = '';
    }
  }

  /**
   * called when the validity of this form is changed
   * @param newValidity
   */
  public handleFormValidChanged(newValidity: boolean) {
    this.onValidChange.emit(newValidity);
  }

  public selectedAssignedToUserChangedHandler = ($event: UserRead) => {
    if (this.event.EventSignUpNotificationEmails.length <= 0) {
      let notifyEmail = new EventSignUpNotificationEmail();
      notifyEmail.UserNum = $event.UserNum;
      notifyEmail.FirstName = $event.FirstName;
      notifyEmail.LastName = $event.LastName;
      notifyEmail.Email = $event.Email;
      this.event.EventSignUpNotificationEmails.push(notifyEmail);
    }
  };

  public paymentMethodsSaved(paymentMethods: Array<EventPaymentMethod>) {
    for (let payMethod of paymentMethods) {
      if (payMethod.PaymentMethodId == 1) {
        this.event.AcceptBillSignUp = payMethod.Accept;
      }
      if (payMethod.PaymentMethodId == 2) {
        this.event.AcceptPayAtDoor = payMethod.Accept;
      }
      if (payMethod.PaymentMethodId == 3) {
        this.event.AcceptCreditCard = payMethod.Accept;
      }
      if (payMethod.PaymentMethodId == 4) {
        this.event.AcceptPo = payMethod.Accept;
      }
    }
  }
}
